import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useContent } from '../content/ContentContext';

const Navbar: React.FC = () => {
  const { settings, navigation } = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled || open ? 'glass-nav border-b border-white/[0.06]' : 'bg-transparent border-b border-transparent'}`}>
      <div className="container-site flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="Dartware Startseite">
          <img src={settings.logo} alt="Dartware GmbH" className="h-[22px] w-auto" />
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Hauptnavigation">
          {navigation.items.map((item) => (
            <a key={item.href} href={item.href} className="rounded-full px-3.5 py-2 text-[14px] text-fg-2 transition hover:text-fg">
              {item.label}
            </a>
          ))}
          <a href={navigation.cta.href} className="btn-primary btn-sm ml-3">{navigation.cta.label}</a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="relative flex h-10 w-10 items-center justify-center rounded-full text-fg md:hidden"
          aria-expanded={open}
          aria-label={open ? 'Menü schließen' : 'Menü öffnen'}
        >
          <span className={`absolute h-[1.5px] w-5 bg-current transition-all duration-300 ${open ? 'rotate-45' : '-translate-y-[4px]'}`} />
          <span className={`absolute h-[1.5px] w-5 bg-current transition-all duration-300 ${open ? '-rotate-45' : 'translate-y-[4px]'}`} />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="glass-nav border-t border-white/[0.06] md:hidden"
            aria-label="Mobile Navigation"
          >
            <div className="container-site flex flex-col gap-1 py-4">
              {navigation.items.map((item) => (
                <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-xl px-3 py-3 text-lg font-medium text-fg">
                  {item.label}
                </a>
              ))}
              <a href={navigation.cta.href} onClick={() => setOpen(false)} className="btn-primary mt-3">{navigation.cta.label}</a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
